import PropTypes from "prop-types";
import { memo } from "react";
import QuotationBoard from "app/pages/Booking/Quotation/Board/QuotationBoard";
import { messagePropType, quotationBoardShape } from "app/utils/propTypes";
import { FormattedMessage } from "react-intl";
import AlertMessage from "app/pages/.shared/AlertMessage";
import "./QuotationBoards.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const QuotationBoards = ({ boards = [], onChange, title }) => {
	const isBoardAvailable = !(boards.length === 1 && boards[0].boardCode === "RO");

	return (
		<div className="quotation-boards">
			<Typography
				variant={TYPOGRAPHY_VARIANTS.LARGE}
				isBold
				className="quotation-boards__subtitle"
				component="h3"
			>
				{title}
			</Typography>
			{isBoardAvailable ? (
				boards.map((board, index) => {
					return (
						<div
							className="quotation-boards__item"
							key={board.code}
							data-testid="quotation-board-item"
						>
							<QuotationBoard
								expandedDetails={index === 0}
								onChange={onChange}
								board={board}
								included={Boolean(board.included && !board.upgradePrice)}
							/>
						</div>
					);
				})
			) : (
				<AlertMessage message={<FormattedMessage id="quotation.board.none" />} />
			)}
		</div>
	);
};

QuotationBoards.propTypes = {
	boards: PropTypes.arrayOf(quotationBoardShape),
	onChange: PropTypes.func,
	title: messagePropType,
};

export default memo(QuotationBoards);
